/** TanStack Query anahtar fabrikası — invalidasyon tek yerden. */
export const queryKeys = {
  meta: {
    all: ['meta'] as const,
    stamp: () => ['meta', 'stamp'] as const,
    menu: (userId: string) => ['meta', 'menu', userId] as const,
    icons: () => ['meta', 'icons'] as const,
    dashboards: (userId: string) => ['meta', 'dashboards', userId] as const,
    screenBundle: (screenId: string) => ['meta', 'screenBundle', screenId] as const,
    objectBundle: (objectId: string) => ['meta', 'objectBundle', objectId] as const,
    lookupBatch: (objectId: string) => ['meta', 'lookupBatch', objectId] as const,
  },
  data: {
    object: (objectId: string) => ['data', objectId] as const,
    select: (objectId: string, filterId: string | null, where: string | null, maxRecords: number | null) =>
      ['data', objectId, 'select', filterId, where, maxRecords] as const,
    lookup: (fieldId: string) => ['data', 'lookup', fieldId] as const,
  },
  user: {
    setting: (userId: string, key: string) => ['user', 'setting', userId, key] as const,
    profileImage: (userId: string) => ['user', 'profileImage', userId] as const,
  },
  misc: {
    exchangeRates: () => ['misc', 'exchangeRates'] as const,
  },
  device: {
    all: ['device'] as const,
    list: () => ['device', 'list'] as const,
    detail: (deviceId: string) => ['device', 'detail', deviceId] as const,
    /** Bu bilgisayardaki ajanın kimliği (127.0.0.1 whoami). */
    local: () => ['device', 'local'] as const,
    /** Yazdırma kuyruğu / geçmişi (Tb_Rn_Sys_DevicePrintJobs). */
    printJobs: () => ['device', 'printJobs'] as const,
    /** Sunucudaki ajan paketi (indirme düğmesi). */
    agentPackage: () => ['device', 'agentPackage'] as const,
  },
};
